import { Flex, Typography } from "antd";
import { useMemo, useRef } from "react";
import { getStepId, getTrackingOp, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { datetime } from "../../../../util/library/datetime";
import { EXECUTION_TYPE } from "../../../../util/varibles/constants";
import { IActivityLog, ITreatment2 } from "../../../../util/varibles/interface";
import { ChecklistsSection } from "../ChecklistsForm";
import FinishStepButton from "../FinishStepButton";

export default function CompletedStep({ log, arrived, stepIndex }: { log: IActivityLog, arrived?: IActivityLog, stepIndex: number }) {
    const [op] = useTrackingOp(state => state.op?.operation as ITreatment2);
    const [stepStates] = useTrackingOp(state => state.stepStates);
    const { checklists_v2 = [], execution_type, dead_fish } = op || {};
    const info = useRef({ execution_type, stepIndex, index: log.index })
    const get = getTrackingOp();

    const isDone = useMemo(() => {
        const { execution_type, stepIndex } = info.current;
        if (execution_type === EXECUTION_TYPE.AUTO) {
            return true;
        }
        const { op } = get();
        const stepPrev = op?.activity_log[stepIndex - 1]
        if (!stepPrev)
            return false;
        const stepId = getStepId(stepPrev, stepIndex - 1);
        const state = stepStates?.[stepId]?.state;
        return !!state;
    }, [get, stepStates]);

    const { depature_time, real_start_time: real_departure_time } = log;
    const { arrive_time, real_start_time: real_arrive_time } = arrived || {}
    return <>
        <div className="w-full">
            <Flex gap={6}>
                <Typography.Text type="secondary">Arrived at site: </Typography.Text>
                <Typography.Text>{(arrive_time || real_arrive_time) ? datetime(arrive_time || real_arrive_time).format("HH:mm. DD/MM") : '--'}</Typography.Text>
            </Flex>
            <Flex gap={6}>
                <Typography.Text type="secondary">Departure:</Typography.Text>
                <Typography.Text>{(depature_time || real_departure_time) ? datetime(depature_time || real_departure_time).format("HH:mm. DD/MM") : '--'}</Typography.Text>
            </Flex>
            <Flex gap={6}>
                <Typography.Text type="secondary">∑ dead fish in whole treatment:</Typography.Text>
                <Typography.Text>{dead_fish ? dead_fish : '--'}</Typography.Text>
            </Flex>

            <ChecklistsSection data={checklists_v2} />

        </div>
        {isDone && <FinishStepButton name="Completed" payload={execution_type === EXECUTION_TYPE.AUTO ? { movement_type: "complete" } : {}} />}
    </>
}